

















































































































































































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import { timeoutDefault } from '@/utils/common'
import { EtapaEnum, SituacaoEnum, CancelarSolicitacaoParam, TipoOrigemEnum } from '@/types/_'
import SolicitacaoCirurgiaApi from '@/Apis/Agendamento/Services/SolicitacaoCirurgiaApi'
import EventBus from '@/plugins/EventBus'
import { permissionService } from '@/services/permission.service'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import BackofficeFidelizacaoStore from '@/components/Backoffice/Store/BackofficeFidelizacaoStore'

@Component
export default class SurgerySolicitationReadOnlyPageComponent extends Vue {
  @Prop({ default: false }) showHeader: boolean
  @Prop({ default: false }) loadingClose: boolean

  loadingUpdateCategoriaDoPlanoParaFidelizacao = false

  @Emit('close')
  close() { }

  get defaultPageAuthorizedValue() {
    const { pageAuthorized } = this.$user.profile

    return pageAuthorized.find((item) => {
      try {
        const parsed = JSON.parse(item)
        return typeof parsed === 'object' && parsed !== null
      } catch (e) {
        return false
      }
    })
  }

  get backofficeArea() {
    return this.getBackofficeGlobalStore.backofficeArea
  }

  temQuantidadeAutorizada(grupoOpme: any) {
    const truthyValues: boolean[] = []
    grupoOpme.forEach((grupo: any) => {
      grupo.opmes.forEach((opme: any) => {
        // eslint-disable-next-line
        truthyValues.push(opme.hasOwnProperty('quantidadeAutorizada'))
      })
    })
    return truthyValues.some((e: boolean) => e === true)
  }

  loadClose: boolean = false
  loadCancelamento: boolean = false

  get hospitalBlumenau() {
    const { solicitacao } = this.getBackofficeGlobalStore
    if (solicitacao && solicitacao.hospital && !!solicitacao.hospital.nome) return solicitacao.hospital.nome === 'Hospital Santa Catarina Blumenau'
    return false
  }

  get getAutorizacaoAnexo() {
    if (this.getBackofficeGlobalStore.solicitacao.etapa.key === EtapaEnum.agendamento) {
      return {
        pedidoMedico: true,
        laudo: true,
        cotacaoOpme: true,
        laudoAnestesista: false,
        anexoOperadora: false,
        resumo: true,
      }
    }

    return {
      pedidoMedico: true,
      laudo: true,
      cotacaoOpme: true,
      laudoAnestesista: true,
      anexoOperadora: true,
      resumo: true,
    }
  }

  get getAutorizacao() {
    return this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.Autorizada
      || this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.AutorizadaParcial
      || this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.AutorizadaAceitaMedico
      || this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.AguardandoOperadora
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: boolean) {
    this.loadCancelamento = value
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get canShowComparativoDeProtocolo() {
    return this.backofficeArea === 'fidelizacao' || this.backofficeArea === 'regulacao'
  }

  get canShowCategoriaDoPlanoParaFidelizacao() {
    return permissionService.hasPermission('agendamento.backoffice.protocolo.visualizarProductLine')
      && (this.backofficeArea === 'fidelizacao' || this.backofficeArea === 'regulacao')
  }

  get categoriaDoPlanoParaFidelizacao() {
    return this.getBackofficeGlobalStore.solicitacao.categoriaDoPlanoParaFidelizacao!
  }

  async updateCategoriaDoPlanoParaFidelizacao(categoria: string) {
    this.loadingUpdateCategoriaDoPlanoParaFidelizacao = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const categoriaDoPlanoParaFidelizacao = categoria || this.categoriaDoPlanoParaFidelizacao!

    try {
      const res = await SolicitacaoCirurgiaApi.updateCategoriaDoPlanoParaFidelizacao(solicitacaoId, categoriaDoPlanoParaFidelizacao)

      if (res.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Categoria salva com sucesso!', icon: 'done', color: '#2E7D32' })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao alterar a categoria!', icon: 'warning', color: '#C62828' })
      }
    } finally {
      this.loadingUpdateCategoriaDoPlanoParaFidelizacao = false
    }
  }

  get backofficeFidelizacaoStore() {
    return getModule(BackofficeFidelizacaoStore, this.$store)
  }

  get backofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  async showModalCancelamento() {
    this.loadingCancelamento = true
    await timeoutDefault()
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      modal: 'triagem',
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoTriagem(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId })
    this.loadingCancelamento = false
  }

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        document.getElementsByClassName('v-dialog')[0].scrollTop = 0
      }
    }
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('scroll_top_visualizacao')
    if (ele.length > 0) {
      ele[0].scrollTo(0, 0)
    }
  }

  windowWidth: number = 0
  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
